import React from 'react'
import {useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {getPriceActiveLabel} from 'components/Filters/utils'
import {useFiltersForm} from 'hooks/useFiltersForm'
import {usePriceFilter} from 'hooks/usePriceFilter'
import useShowOverlay from 'hooks/useShowOverlay/useShowOverlay'
import {getCurrencyCode} from 'modules/meta/selectors'
import {OverlayType} from 'modules/overlay/types'
import {searchParamToFacet} from 'modules/search/constants'
import {prop} from 'ramda'

import {Pill} from '@vio/atlas/Pill'
import {getEnabledCurrencies} from '@vio/core/src/localization/business/currency'

import {PriceFilterBottomSheet} from './PriceFilterBottomSheet'

const filterKeys = [
  searchParamToFacet.priceMin.param,
  searchParamToFacet.priceMax.param
]

const ActiveLabel = styled.span`
  text-transform: none;
`

interface Props {
  isActive?: boolean
}

export const PriceFilterPill: React.FC<Props> = ({isActive = false}) => {
  const {getTotalPriceFilter} = usePriceFilter()

  const showOverlay = useShowOverlay()
  const {formatMessage} = useIntl()
  const {getAppliedFilters} = useFiltersForm(filterKeys, 'price')

  const currencyCode = useSelector(getCurrencyCode)
  const enabledCurrencies = getEnabledCurrencies(
    process.env.NEXT_PUBLIC_ENABLED_CURRENCIES
  )
  const currency = enabledCurrencies.find(
    currency => currency.code === currencyCode
  )
  const currencySymbol = prop('symbol', currency)

  const appliedFilters = getAppliedFilters()

  const appliedPriceMin = getTotalPriceFilter(appliedFilters.priceMin)
  const appliedPriceMax = getTotalPriceFilter(appliedFilters.priceMax)

  const handleOnPillClick = () => {
    showOverlay({
      type: OverlayType.PriceFilter
    })
  }

  const label = isActive ? (
    <ActiveLabel>
      {getPriceActiveLabel({
        minPrice: appliedPriceMin,
        maxPrice: appliedPriceMax,
        currencySymbol,
        formatMessage
      })}
    </ActiveLabel>
  ) : (
    formatMessage({id: 'priceFilter', defaultMessage: 'Price'})
  )

  return (
    <>
      <Pill
        dataId="priceFilter"
        onClick={handleOnPillClick}
        isSelected={isActive}
        showArrow
      >
        {label}
      </Pill>
      <PriceFilterBottomSheet />
    </>
  )
}
